// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-ecommerce-layout',
    props: {
        widthMode: {
            type: String,
            required: false,
            default: 'default'
        },
        metaData: {
            type: Object,
            required: false,
            default: {}
        },
    },
    computed: {
        getStickyMenu() {
            return this.$appHost.store.get("session")?.stickyMenu;
        },
    },
});
// #endregion
